import React from "react";
import { NewSchedulingTemplate } from "../../Templates/NewSchedulingTemplate";

export const NewScheduling = () => {
  return <NewSchedulingTemplate />;
};
